import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Section } from './Section';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { cierreComparativa } from '../data/comparativas';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE } from '../lib/config';
export function Close() {
  return <Section tone="ink" className="py-20 md:py-32" data-id="element-45" data-mp="1pygjkluplmsv">
      <div className="flex flex-col items-center text-center" data-id="element-46" data-mp="1kzwvaesn7yxc">
        <h2 className="max-w-[26ch] font-serif text-[30px] leading-[1.15] sm:text-[42px]" data-id="element-47" data-mp="1l1gead5ooo2t">
          Deja de improvisar el día más importante de la vida de otra persona.
        </h2>

        <p className="measure mt-7 text-[15px] leading-relaxed text-ivory/70 sm:text-base" data-id="element-48" data-mp="1c8d2saelmlat">
          Únete a las organizadoras que dirigen cada fiesta con un sistema:
          tranquilas el día del evento, premium en el presupuesto y con la
          agenda llena por recomendación.
        </p>

        <p className="kicker mt-8 max-w-[46ch]" data-id="element-49" data-mp="xbvuxt5mbot0">
          Concepto · Presupuesto · Logística · Ventas · Proveedores · Crisis —
          todo resuelto
        </p>
      </div>

      <ul className="mx-auto mt-14 flex max-w-[880px] flex-col gap-4 md:gap-0" data-id="element-50" data-mp="40ze5585hxds">
        <li className="hidden grid-cols-2 gap-x-8 md:grid" data-id="element-51" data-mp="3lhh92fvsfb89">
          <p className="pb-4 text-[11px] uppercase tracking-[0.18em] text-ivory/50" data-id="element-52" data-mp="3lf4khjviy2m8">
            Sin el sistema
          </p>
          <p className="pb-4 text-[11px] uppercase tracking-[0.18em] text-gold" data-id="element-53" data-mp="i0im9y0yp8q3">
            Con el Master Plan 15
          </p>
        </li>

        {cierreComparativa.map(row => <li key={row.after} className="grid gap-3 md:grid-cols-2 md:gap-x-8 md:border-t md:border-white/10 md:py-6" data-id="element-54" data-mp="mx91kj4y00ag">
            <div className="flex items-start gap-3 rounded-card bg-white/5 p-4 md:bg-transparent md:p-0" data-id="element-55" data-mp="d04e8fzd1ys2">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-blush" strokeWidth={2.5} aria-hidden="true" data-id="element-56" data-mp="2srs6hy3fj34j" />
              <p className="text-[15px] leading-relaxed text-ivory/60" data-id="element-57" data-mp="149fqqar239uf">
                <span className="mb-1 block text-[10px] uppercase tracking-[0.18em] text-ivory/40 md:hidden" data-id="element-58" data-mp="z9unho4usfbw">
                  Sin el sistema
                </span>
                {row.before}
              </p>
            </div>

            <div className="flex items-start gap-3 rounded-card border border-gold/30 p-4 md:border-0 md:p-0" data-id="element-59" data-mp="pkta85pp0c1m">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-60" data-mp="klzsg13dhyvn" />
              <p className="text-[15px] font-medium leading-relaxed text-ivory" data-id="element-61" data-mp="bk0g3m3aziz1">
                <span className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.18em] text-gold md:hidden" data-id="element-62" data-mp="6l5kfjk8lzxi">
                  Con el Master Plan 15
                </span>
                {row.after}
              </p>
            </div>
          </li>)}
      </ul>

      <div className="mt-16 flex flex-col items-center" data-id="element-63" data-mp="20x3t9kemwtsv">
        <p className="kicker" data-id="element-64" data-mp="28ho7lgsbo6am">El precio de lanzamiento termina en</p>
        <div className="mt-5" data-id="element-65" data-mp="2dhiwxfwg8ntk">
          <Countdown tone="dark" size="sm" data-id="element-66" data-mp="2dgr247aoeu4c" />
        </div>

        <p className="mt-10 text-[15px] text-ivory/70" data-id="element-67" data-mp="2i8isohtu0zuh">
          MASTER PLAN 15 — 6 tomos + 5 bonos ·{' '}
          <span className="line-through text-ivory/40" data-id="element-68" data-mp="2n7c7qeoroywr">{REGULAR_PRICE}</span>{' '}
          <span className="font-serif text-2xl text-gold" data-id="element-69" data-mp="2n9gdl26887zo">→ {PRICE}</span>
        </p>

        <div className="mt-8 w-full max-w-[520px]" data-id="element-70" data-mp="1ply57sgh97w7">
          <CtaButton href={CHECKOUT_URL} size="xl" tone="dark" microcopy="Pago 100% seguro · Acceso inmediato · Garantía de 7 días" className="[&>a]:w-full" data-id="element-71" data-mp="1ui52kwut5b2j">
            Sí, quiero el Master Plan 15
          </CtaButton>
        </div>
      </div>
    </Section>;
}